import Vue from 'vue'

const state = Vue.observable({ items: [] })
const timers = new Map()
let nextId = 0

function remove (id) {
  window.clearTimeout(timers.get(id))
  timers.delete(id)
  const index = state.items.findIndex(item => item.id === id)
  if (index >= 0) state.items.splice(index, 1)
}

function show (text, type = 'info') {
  const value = String(text == null ? '' : text).trim()
  if (!value) return null
  const kind = ({ err: 'error', warn: 'warning', ok: 'success' })[type] || (['success', 'error', 'warning', 'info'].includes(type) ? type : 'info')
  let item = state.items.find(entry => entry.text === value && entry.type === kind)
  if (!item) {
    item = { id: ++nextId, text: value, type: kind }
    state.items.push(item)
    while (state.items.length > 4) remove(state.items[0].id)
  }
  window.clearTimeout(timers.get(item.id))
  timers.set(item.id, window.setTimeout(() => remove(item.id), kind === 'error' ? 6000 : 4000))
  return item.id
}

export default {
  state,
  show,
  remove,
  success (text) { return show(text, 'success') },
  error (text) { return show(text, 'error') },
  warning (text) { return show(text, 'warning') },
  info (text) { return show(text, 'info') }
}
